// extracted by mini-css-extract-plugin
module.exports = {"preloaderContainer":"Preloader__preloaderContainer--am0","loader":"Preloader__loader--1wJ","cancelButton":"Preloader__cancelButton--2fL"};